export const SET_CURATION_FILTER = "SET_CURATION_FILTER";
export const UNSET_CURATION_FILTER = "UNSET_CURATION_FILTER";

export const setCurationFilter = filters => {
  return {
    type: SET_CURATION_FILTER,
    payload: filters,
  };
};

export const unsetCurationFilter = filters => {
  return {
    type: UNSET_CURATION_FILTER,
    payload: filters,
  };
};

export const unsetAllFilters = () => {
  return (dispatch, getState) => {
    const { filters } = getState().curation;
    Object.keys(filters).forEach(filter =>
      dispatch(unsetCurationFilter(filter))
    );
  };
};
